import chroma from 'chroma-js';
import { TRANSITION_ANIMATION_BACKGROUND_COLOR } from '../../../styles/colors';
import { isLocalhostEnvironment, isTestEnvironment } from '../../../utils/utils';
/**
 * Time in seconds for each half of the transition animation.
 */
const DEFAULT_TRANSITION_HALF_DURATION_MS = isLocalhostEnvironment() ? 750 : 1500;
/**
 * Use a very short transition animation in tests unless specifically enabled on a per-test basis.
 */
function getTransitionHalfAnimationMs() {
    if (isTestEnvironment()) {
        const params = new URLSearchParams(window.location.search);
        return params.get('showTransitionAnimation') === 'true' ? 500 : 10;
    }
    return DEFAULT_TRANSITION_HALF_DURATION_MS;
}
export const TRANSITION_HALF_DURATION_MS = getTransitionHalfAnimationMs();
export const TRANSITION_CONTAINER_Z_INDEX = 2000; // above MUI modal z-index
export const TRANSITION_ANIMATION_ARIA_LABEL = 'loading animation';
function createTransitionAnimationColors() {
    const colorScale = chroma.scale(['black', TRANSITION_ANIMATION_BACKGROUND_COLOR]);
    return [colorScale(0.7), colorScale(0.85), colorScale(1)].map((color) => color.hex());
}
export const TRANSITION_ANIMATION_COLORS = createTransitionAnimationColors();
